var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_right_blue",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2928932,0.292893219 C11.6834175,-0.0976310729 12.3165825,-0.0976310729 12.7071068,0.292893219 C13.0675907,0.65337718 13.0953203,1.22060824 12.7902954,1.61289944 L12.7071068,1.70710678 L6.415,8 L12.7071068,14.2928932 C13.0675907,14.6533772 13.0953203,15.2206082 12.7902954,15.6128994 L12.7071068,15.7071068 C12.3466228,16.0675907 11.7793918,16.0953203 11.3871006,15.7902954 L11.2928932,15.7071068 L4.29289322,8.70710678 C3.93240926,8.34662282 3.90467972,7.77939176 4.20970461,7.38710056 L4.29289322,7.29289322 L11.2928932,0.292893219 Z",
    id: "Path-28",
    fill: "#3368FF",
    fillRule: "nonzero",
    transform: "translate(8.500000, 8.000000) scale(-1, 1) translate(-8.500000, -8.000000) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlue);
export default __webpack_public_path__ + "static/media/arrow_right_blue.c20ea9be27296df216bd18082bb043c0.svg";
export { ForwardRef as ReactComponent };